import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LogoWhite from "../../assets/logo-2mm-blanc.png";
import LanguageSwitcher from "../LanguageSwitcher";
import ShellIcon from "./ShellIcon";
import { findCurrentItem, ShellNavGroup } from "./proNav";
import { useLogout } from "./useLogout";

// Barre du haut de l'espace professionnel (maquette v3 : topbar sur bureau, appbar sur mobile).
// Le fil d'Ariane est lu dans le menu (proNav) : une page hors menu n'affiche que l'organisation.
// Chaque étape est un lien ; celle de la page affichée est marquée active (NavLink) et mise en gras.

const ProTopbar = ({
  organizationName,
  groups,
  guideLink,
  menuOpened,
  onOpenMenu,
}: {
  organizationName: string;
  groups: ShellNavGroup[];
  guideLink: string | null;
  menuOpened: boolean;
  onOpenMenu(): void;
}) => {
  const { t } = useTranslation(["common"]);
  const { pathname } = useLocation();
  const logout = useLogout();
  const current = findCurrentItem(groups, pathname);
  const home = groups[0]?.items[0]?.to ?? "/organization";

  return (
    <>
      <header className="topbar">
        {/* Fil d'Ariane cliquable (Nicolas, 01/11) : l'organisation mène à l'accueil, la rubrique à sa page. */}
        <nav className="topbar_crumb" aria-label={t("common:shell.BREADCRUMB")}>
          <Link to={home}>{organizationName}</Link>
          {current?.group.title && (
            <>
              <ShellIcon name="chevron" />
              <span>{current.group.title}</span>
            </>
          )}
          {current && (
            <>
              <ShellIcon name="chevron" />
              <NavLink to={current.item.to} end>
                {current.item.label}
              </NavLink>
            </>
          )}
        </nav>
        <span className="topbar_sp" />
        {guideLink && (
          <a
            className="tlink"
            href={guideLink}
            target="_blank"
            rel="noreferrer"
          >
            <ShellIcon name="book" />
            {t("common:header.RECRUITER_GUIDE")}
          </a>
        )}
        <LanguageSwitcher />
        <button
          type="button"
          className="iconbtn"
          onClick={logout}
          title={t("common:sidebar.buttons.LOGOUT")}
          aria-label={t("common:sidebar.buttons.LOGOUT")}
        >
          <ShellIcon name="logout" />
        </button>
      </header>

      <header className="appbar">
        <button
          type="button"
          className="iconbtn"
          onClick={onOpenMenu}
          aria-label={t("common:shell.OPEN_MENU")}
          aria-expanded={menuOpened}
        >
          <ShellIcon name="menu" />
        </button>
        <NavLink className="appbar_logo" to={home}>
          <img src={LogoWhite} alt="2 Minutes Max" />
        </NavLink>
        <span className="appbar_ttl">{current?.item.label}</span>
      </header>
    </>
  );
};

export default ProTopbar;
